// extracted by mini-css-extract-plugin
module.exports = {"box":"style_box__63vp1","align-left":"style_align-left__LrWOn","align-center":"style_align-center__1LVhJ","size-sm":"style_size-sm__2FrqL","size-lg":"style_size-lg__3SbaH"};